export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'Quejas',
      active: true,
      icon: 'copy',
      to: '/'
    },
    {
      name: 'Quejas En Proceso',
      active: true,
      icon: 'archive',
      to: '/Quejas/Abiertas'
    }
  ]
};
export const operationsRoutes = {
  label: 'Operaciones',
  labelDisable: false,
  children: [
    // {
    //   name: 'Crear Queja',
    //   active: true,
    //   exact: true,
    //   icon: 'file',
    //   to: '/Quejas/add'
    // },
    {
      name: 'Nueva Queja',
      active: true,
      exact: true,
      icon: 'file',
      to: '/Quejas/new'
    },
    {
      name: 'Calendario',
      active: true,
      exact: true,
      icon: 'calendar',
      to: '/Quejas/Calendario'
    },
    {
      name: 'Semana',
      active: true,
      exact: true,
      icon: 'calendar-minus',
      to: '/Quejas/CalendarioSem'
    }
  ]
};

export const reportesRoutes = {
  label: 'Reportes',
  labelDisable: false,
  children: [
    {
      name: 'Reporte de Quejas',
      active: true,
      exact: true,
      icon: 'file-excel',
      to: '/reportes/quejas'
    },
    {
      name: 'Reporte por Periodo',
      active: true,
      exact: true,
      icon: 'file-excel',
      to: '/reportes/quejasperiodo'
    }
  ]
};
export const configurationRoutes = {
  label: 'Configuracion',
  labelDisable: false,
  children: [
    {
      name: 'Municipios',
      to: '/Configuration/Municipios',
      exact: true,
      icon: 'city',
      active: true
    },
    // {
    //   name: 'NOMs',
    //   to: '/Configuration/Noms',
    //   exact: true,
    //   icon: 'bookmark',
    //   active: true
    // },
    {
      name: 'Codigos Postales',
      to: '/Configuration/Cps',
      exact: true,
      icon: 'map',
      active: true
    },
    {
      name: 'Tipos de Producto',
      to: '/Configuration/producttypes',
      exact: true,
      icon: 'barcode',
      active: true
    },
    // {
    //   name: 'Tipos de Violaciones',
    //   to: '/Configuration/violationtypes',
    //   exact: true,
    //   icon: 'unlock',
    //   active: true
    // },
    {
      name: 'Tipos de Eventos',
      to: '/Configuration/eventtypes',
      exact: true,
      icon: 'newspaper',
      active: true
    },
    // {
    //   name: 'Tipos de Status',
    //   to: '/Configuration/statustypes',
    //   exact: true,
    //   icon: 'star',
    //   active: true
    // },
    // {
    //   name: 'Status',
    //   to: '/Configuration/status',
    //   exact: true,
    //   icon: 'check',
    //   active: true
    // },
    {
      name: 'Tipo Plataforma',
      to: '/Configuration/TiposPlataforma',
      exact: true,
      icon: 'cog',
      active: true
    },
    {
      name: 'Formatos Queja',
      to: '/administration/FormatosQueja',
      exact: true,
      icon: 'file-code',
      active: true
    }
  ]
};
export const administrationRoutes = {
  label: 'Administracion',
  labelDisable: false,
  children: [
    {
      name: 'Clientes',
      active: true,
      exact: true,
      icon: 'users',
      to: '/Administration/clientes'
    },
    {
      name: 'Determinantes',
      to: '/Administration/determinantes',
      exact: true,
      icon: 'kaaba',
      active: true
    },
    {
      name: 'Clasificaciones',
      to: '/Administration/Clasifications',
      exact: true,
      icon: 'th',
      active: true
    },
    {
      name: 'Clas. Walmart',
      to: '/Administration/Clasificationswm',
      exact: true,
      icon: 'store',
      active: true
    },
    {
      name: 'Clas. Profeco',
      to: '/Administration/clasificationsprofeco',
      exact: true,
      icon: 'store',
      active: true
    },
    {
      name: 'Delegaciones',
      to: '/Administration/delegations',
      exact: true,
      icon: 'hotel',
      active: true
    }
  ]
};
export const securityRoutes = {
  label: 'Seguridad',
  labelDisable: false,

  adminRoute: true,
  children: [
    {
      name: 'Usuarios',
      to: '/security/Users',
      exact: true,
      icon: 'user',
      active: true
    }
  ]
};
export default [
  dashboardRoutes,
  operationsRoutes,
  administrationRoutes,
  configurationRoutes,
  reportesRoutes,
  securityRoutes
];
